import React from 'react';
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";

export const LoyaltyBarWrapperComponent = observer(class LoyaltyBarWrapperComponent extends OrbitComponent {
    componentDidMount() {
        super.componentDidMount();
        this.services.loyaltyIndicator.init();
    }

    render() {
        return (
            <div id="rl-loyalty-indication" />
        );
    }
});